import React, { useEffect, useRef, useState } from "react";
import leftvector from "../../images/leftvector.png";
import rightvector from "../../images/rightvector.png";
import PoundW from "../../images/PoundW.png";
import Pound from "../../images/Pound.png";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useSelector, useDispatch } from "react-redux";
import {
  buyplan,
  fetchSubscriptionProducts,
  card_details,
  customer_subscription,
} from "../../redux/authslice";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import Card from "../manageplanfree/Card";
import Loading from "../../Loader/Loader";

function RenderPlans(
  planType,
  cardDetails,
  subplan,
  handleShow,
  handleShow1,
  handleShowpay,
  customersubscrip,
  selectedOption,
  setSubdata,
  setShowpay,
  showpay,
  autopay
) {
  const dispatch = useDispatch();
  const { subscriptionProducts } = useSelector((state) => state.counter);
  const filteredproducts = subscriptionProducts?.filter(
    (product) => product.interval === subplan
  );
  const handlebuy = (name, price) => {
    if (
      customersubscrip &&
      customersubscrip?.length > 0 &&
      customersubscrip[0]?.price !== "0.00" &&
      price !== 0
    ) {
      handleShow1();
    } else {
      if (
        cardDetails?.length === 0 ||
        cardDetails?.length === null ||
        (cardDetails?.length === undefined && name && price !== 0)
      ) {
        localStorage.setItem("iddd", name);
        handleShowpay();
      } else if (name && price === 0) {
        // dispatch(
        //   buyplan({
        //     price: name,
        //     dispatch,
        //   })
        // );
        handleShow1();
      } else {
        const product = filteredproducts.find(
          (product) => product.price_id === name
        );
        if (product) {
          handleShow();
          setSubdata({
            price_id: product.price_id,
            payment_method_id: selectedOption,
          });
        }
      }
    }
  };

  if (!filteredproducts?.length) {
    return <p className="top-head-price-p1-p">No data found !</p>;
  } else {
  }

  const sortedPlans = filteredproducts.sort((a, b) => {
    const order = ["Basic", "Advanced", "Pro"];
    return order.indexOf(a.level) - order.indexOf(b.level);
  });

  return sortedPlans?.map((plan, index) => (
    <>
      <div className="col-lg-4" key={index}>
        <div className={`common-price ${plan.popular ? "advance" : ""}`}>
          {plan.popular && <button className="advance-bt">Most Popular</button>}
          <p className="common-price-p1">{plan?.level}</p>
          <p className="common-price-p2">{plan?.token} Questions</p>
          <p className="common-price-p3">
            <img src={plan?.popular ? PoundW : Pound} alt="" />
            <span
              className="span-22"
              style={{ color: plan?.popular ? "#fff" : "" }}
            >
              {plan?.product_price}
            </span>
            <span
              className="span-33"
              style={{ color: plan?.popular ? "#fff" : "" }}
            >
              /{plan?.interval}
            </span>
          </p>
          <ul>
            {plan?.description.split("\n")?.map((line, i) => (
              <li key={i}>
                <span />
                <p>{line}</p>
              </li>
            ))}
          </ul>
          <button
            className="Chooseplan"
            disabled={
              parseFloat(customersubscrip[0]?.price) == plan?.product_price
            }
            style={{
              color: plan.popular ? "#ffffff" : "",
              background: plan.popular ? "#2F3A55" : "",
              border: plan.popular ? "1px solid #2F3A55" : "",
            }}
            onClick={() => handlebuy(plan.price_id, plan.product_price)}
          >
            {parseFloat(customersubscrip[0]?.price) == plan?.product_price
              ? "Active Plan"
              : "Buy Plan"}
          </button>

          <div></div>
        </div>
      </div>
    </>
  ));
}

function PaymentSubscriptions() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cardDetails, customersubscrip } = useSelector(
    (state) => state.counter
  );
  const [subdata, setSubdata] = useState({
    price_id: "",
    payment_method_id: "",
  });

  const [autopay, setAutopay] = useState(false);

  const [selectedOption, setSelectedOption] = useState(null || undefined);
  const [subplan, setSubplan] = useState("monthly");

  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [showpay, setShowpay] = useState(false);
  const autopayExecuted = useRef(false);
  const [load, setLoad] = useState(false);

  const handleClose = () => {
    setShow(false);
    setSelectedOption(null);
  };
  const handleShow = () => setShow(true);
  const handleClose1 = () => setShow1(false);
  const handleClosepay = () => setShowpay(false);
  const handleShow1 = () => setShow1(true);
  const handleShowpay = () => setShowpay(true);
  const handlesubmit = () => {
    dispatch(
      buyplan({
        price: subdata.price_id,
        cardDetails: selectedOption,
        dispatch,
        setLoad,
        setShow,
      })
    );
    setShow(false);
  };

  const handleRadioChange = (id) => {
    setSelectedOption((prevSelectedOption) => {
      if (prevSelectedOption === id) {
        return null;
      }
      return id;
    });
  };

  useEffect(() => {
    if (autopay && customersubscrip?.length === 0 && !autopayExecuted.current) {
      setLoad(true);
      autopayExecuted.current = true;
      dispatch(card_details({ dispatch }));
      const dataid = localStorage.getItem("iddd");
      const datacard = cardDetails[0].id;

      dispatch(
        buyplan({
          price: dataid,
          cardDetails: datacard,
          dispatch,
          setLoad,
        })
      );
    }
  }, [autopay, customersubscrip]);

  useEffect(() => {
    dispatch(card_details({ dispatch }));
    dispatch(customer_subscription(dispatch));
    dispatch(fetchSubscriptionProducts());
  }, [dispatch]);

  useEffect(() => {
    let defkt = cardDetails?.find((ele) => ele.default === true);
    setSelectedOption(defkt?.id);
  }, [cardDetails, show]);

  return (
    <>
      {load && <Loading />}
      <div>
        <section className="Payment-Subscriptions">
          <img className="left-vec" src={leftvector} alt="" />
          <img className="right-vec" src={rightvector} alt="" />
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <button
                  className="div-save-bt"
                  onClick={() => {
                    localStorage.removeItem("iddd");
                    navigate(-1);
                  }}
                >
                  <IoMdArrowRoundBack />
                  &nbsp;Back
                </button>
                <div className="top-head-price">
                  <p className="top-head-price-p1">Choose your plan</p>
                  <p className="top-head-price-p2">
                    Find the right plan for you
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="top-tabs">
                  <ul
                    className="nav nav-pills mb-3"
                    id="pills-tab"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="pills-home-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-home"
                        type="button"
                        role="tab"
                        aria-controls="pills-home"
                        aria-selected="true"
                        onClick={() => setSubplan("monthly")}
                      >
                        Monthly
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="pills-profile-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-profile"
                        type="button"
                        role="tab"
                        aria-controls="pills-profile"
                        aria-selected="false"
                        onClick={() => setSubplan("quarterly")}
                      >
                        Quarterly
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="pills-contact-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-contact"
                        type="button"
                        role="tab"
                        aria-controls="pills-contact"
                        aria-selected="false"
                        onClick={() => setSubplan("yearly")}
                      >
                        Yearly
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content" id="pills-tabContent">
                    <div
                      className="tab-pane fade show active"
                      id="pills-home"
                      role="tabpanel"
                      aria-labelledby="pills-home-tab"
                    >
                      <div className="row">
                        {RenderPlans(
                          "monthly",
                          cardDetails,
                          subplan,
                          handleShow,
                          handleShow1,
                          handleShowpay,
                          customersubscrip,
                          selectedOption,
                          setSubdata,
                          setShowpay,
                          showpay,
                          autopay
                        )}
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="pills-profile"
                      role="tabpanel"
                      aria-labelledby="pills-profile-tab"
                    >
                      <div className="row">
                        {RenderPlans(
                          "quarterly",
                          cardDetails,
                          subplan,
                          handleShow,
                          handleShow1,
                          handleShowpay,
                          customersubscrip,
                          selectedOption,
                          setSubdata,
                          setShowpay,
                          showpay,
                          autopay
                        )}
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="pills-contact"
                      role="tabpanel"
                      aria-labelledby="pills-contact-tab"
                    >
                      <div className="row">
                        {RenderPlans(
                          "yearly",
                          cardDetails,
                          subplan,
                          handleShow,
                          handleShow1,
                          handleShowpay,
                          customersubscrip,
                          selectedOption,
                          setSubdata,
                          setShowpay,
                          showpay,
                          autopay
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal
        show={showpay}
        onHide={handleClosepay}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add new card</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}
        >
          <Card setShowpay={setShowpay} setAutopay={setAutopay} />
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "none" }} />
      </Modal>

      <div className="A-Privacy">
        <Modal
          show={show}
          onHide={handleClose}
          size="lg"
          backdrop="static"
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Your Card details</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}
          >
            <table>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Name on Card</th>
                  <th>Card Number</th>
                  <th>Expiration Year</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {cardDetails?.map((ele, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{ele?.name_on_card}</td>
                    <td>{`** ** **** ${ele?.card_number}`}</td>
                    <td>{ele?.exp_year}</td>
                    <td>
                      <Form>
                        <div key={`inline-radio-${index}`} className="p">
                          <Form.Check
                            inline
                            name="group1"
                            checked={selectedOption === ele.id}
                            type="radio"
                            id={`inline-radio-${index}`}
                            onChange={() => handleRadioChange(ele.id)}
                          />
                        </div>
                      </Form>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: "none" }}>
            <Button
              variant="secondary"
              onClick={handlesubmit}
              disabled={selectedOption === null || selectedOption === undefined}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      <Modal
        show={show1}
        onHide={handleClose1}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "red" }}> Warning !</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="modal-p-css">
            <b>Already have an active plan!</b>
          </p>
        </Modal.Body>
        <Modal.Footer
          style={{
            textAlign: "center",
            justifyContent: "center",
            height: "41px",
          }}
        ></Modal.Footer>
      </Modal>
    </>
  );
}

export default PaymentSubscriptions;
